export const getEmployeesByCompanyNameQuery = (companyName: string) => { 
    return `
    {
      employeesByCompanyName(companyName:"${companyName}"){
        id
        entity{
          name
        }
        email
        createdAt
        updatedAt
        firstName
        lastName
            }
    }
    `
}